module.exports = __webpack_public_path__ + "static/cr-placeholder-video-2bfde56322729d411b9434aed0cb3a4f.png";